<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="yellow" size="40" class="ma-0">
                        <v-icon size="30">receipt</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">Ticket</span>
                    <v-btn @click="$router.push(`/Ticket`);" color="primary"><v-icon>add</v-icon> Agregar</v-btn>
                </v-col>
            </v-row>
        </v-img>
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-dialog v-model="dModalImagen.dialog" max-width="900px">
            <!-- <v-img src="http://localhost/khipu_ist_api/public/storage/2_20210308155319.jpg"></v-img> -->
            <img :src="dModalImagen.src"/>
        </v-dialog>
        <template>
            <v-row dense>
                <v-col cols="4">
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno.replace(',', '')}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPriAlumno.Servicio}}</v-list-item-title><v-list-item-subtitle>Programa de Estudios</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="3">
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPriAlumno.Codigo}}</v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>phone</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPriAlumno.Celular}} - {{dPriAlumno.Telefono}}</v-list-item-title><v-list-item-subtitle>Celular - Telefono</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="3">
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>label</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>TIPO: {{dCrmTicket.tipo}}</v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <v-dialog v-model="dCrmTicketTipoModal.dialog" max-width="500">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="blue-grey" x-small dark v-bind="attrs" v-on="on"><v-icon left>compare_arrows</v-icon> Cambiar Tipo Incidencia</v-btn>
                                        </template>
                                        <template>
                                            <v-card>
                                                <v-toolbar class="justify-end" color="blue-grey" dark>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue-grey" @click="fuCrmTicketTipoUpdate" :loading="dCrmTicketTipoModal.IsUpdating"><v-icon>compare_arrows</v-icon> Cambiar Tipo Incidencia</v-btn>
                                                    <v-btn @click="dCrmTicketTipoModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <v-autocomplete label="Tipo:" v-model="dCrmTicketTipoId"
                                                        :items="dCrmTicketTipos" item-value="id" item-text="nombre"
                                                        filled prepend-inner-icon="assignment_ind"></v-autocomplete>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                    </v-dialog>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>invert_colors</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dCrmTicket.estado}}</v-list-item-title><v-list-item-subtitle>Estado</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="2">
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>event_note</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dCrmTicket.created_at}}</v-list-item-title><v-list-item-subtitle>Fecha Creación</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>event_note</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dCrmTicket.updated_at}}</v-list-item-title><v-list-item-subtitle>Fecha Modificación</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="12">
                    <v-alert icon="message" border="top" prominent text type="info">{{dCrmTicket.detalle}}</v-alert>
                </v-col>
            </v-row>
        </template>
        <v-data-table :headers="dTable.headers" :items="dCrmTicketComentarios" :loading="dTable.loading" :search="dTable.search" class="elevation-1" hide-default-footer :items-per-page="-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
            <template v-slot:top>
                <v-toolbar flat style="background-color:#455A64" dark>
                    <v-toolbar-title>HISTORIAL</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical ></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dModal.dialog" persistent max-width="700px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="dCrmTicket.estado!='Cerrado'" class="mx-4" v-bind="attrs" v-on="on" icon x-small color="blue-grey"><v-icon>send</v-icon></v-btn>
                        </template>
                        <v-card>
                            <v-card-title :class="dModal.tipo <= 1 ? 'primary' : dModal.tipo == 3 ? 'success' : 'error'">
                                <span class="headline" :text="dModal.tipo < 2 ? 'Derivar' : 'Finalizar'"></span>
                                <v-spacer></v-spacer>
                                <v-btn v-if="dModal.tipo <= 1" color="primary" @click="fuModalSave" :loading="dModal.IsUpdating"><v-icon>send</v-icon>Derivar</v-btn>
                                <v-btn v-else-if="dModal.tipo == 3" color="success" @click="fuModalSave" :loading="dModal.IsUpdating"><v-icon>autorenew</v-icon>En Proceso</v-btn>
                                <v-btn v-else color="error" @click="fuModalSave" :loading="dModal.IsUpdating"><v-icon>archive</v-icon> Finalizar</v-btn>
                                <v-btn @click="fuModalClose" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text class="p-0 pt-3">
                                <v-form ref="refModal">
                                    <v-row dense>
                                        <v-col cols="12" xm="12">
                                            <v-textarea ref="refMensaje" v-model="dCrmTicketComentario_mensaje"
                                                prepend-inner-icon="message"
                                                label="Mensaje"
                                                outlined
                                                rows="2"
                                                row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col v-if="dModal.tipo < 2" cols="12" xm="12">
                                            <v-autocomplete ref="refOperador" label="Derivar a:" v-model="dCrmTicketComentario_id_operador"
                                                :items="dPriPersonals" item-value="IdPersonal" item-text="Personal"
                                                outlined prepend-inner-icon="assignment_ind" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                            </v-autocomplete>
                                            <input style="display: none" type="file" @change="onFileSelected" ref="fileInput" accept="image/*" >
                                            <v-btn @click.prevent="$refs.fileInput.click()" color="blue-grey" dark><v-icon left>cloud_upload</v-icon> Subir Imagen</v-btn>
                                            <v-img max-height="139" max-width="250" :src="coImagen"></v-img>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-avatar v-if="item.tipo==1" color="blue" size="36" title="Derivado"><v-icon dark>send</v-icon></v-avatar>
                <v-avatar v-else color="red" size="36" title="Finalizado"><v-icon dark>archive</v-icon></v-avatar>
            </template>
            <template v-slot:[`item.mensaje`]="{ item }">
                <!-- <v-icon v-if="item.file_url" @click.prevent="dModalImagen.dialog=true; dModalImagen.src=item.file_url">image</v-icon>
                <a :href="item.file_url" target="_blank"><v-icon v-if="item.file_url">download</v-icon></a> -->
                <template v-if="item.file_url">
                    <span v-for="elem in item.file_url.split('|')" :key="elem">
                        <template v-if="elem">
                            <!-- <a v-if="elem.includes('zendesk')" :href="elem" target="_blank"><v-icon>download</v-icon></a> -->
                            <!-- <a v-else :href="'http://localhost/khipu_ist_api/public/ticket/'+elem" target="_blank"><v-icon>download</v-icon></a> -->
                            <a :href="'http://academico.khipu.edu.pe/public/ticket/'+elem" target="_blank"><v-icon>download</v-icon></a>
                        </template>
                    </span>
                </template>
                <span v-html="item.mensaje"></span>
            </template>
            <template v-slot:[`item.pripersonal.Usuario`]="{ item }">
                <template v-if="item.pripersonal">
                    <span :title="item.pripersonal.Personal" class="text-no-wrap " :class="{'yellow lighten-3' : item.pripersonal.Usuario==ssUser.Usuario}">{{item.pripersonal.Usuario}}</span>
                </template>
            </template>
            <template v-slot:[`item.pripersonal_asignado.Usuario`]="{ item }">
                <template v-if="item.pripersonal_asignado">
                    <template v-if="item.pripersonal_asignado.Usuario!=ssUser.Usuario">
                        <v-icon v-if="item.is_final" color="primary">check</v-icon>
                        <v-icon v-else color="success">autorenew</v-icon>
                        <span :title="item.pripersonal_asignado.Personal">{{item.pripersonal_asignado.Usuario}}</span>
                    </template>
                    <template v-else>
                        <v-icon v-if="item.is_final" color="primary">check</v-icon>
                        <v-menu v-else bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="dCrmTicket.estado!='Cerrado'" icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuModal(item,1)" color="primary" block><v-icon>send</v-icon> Derivar</v-btn></v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuModal(item,3)" color="success" block><v-icon>autorenew</v-icon> En Proceso</v-btn></v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuModal(item,2)" color="error" block><v-icon>archive</v-icon> Finalizar</v-btn></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <span :title="item.pripersonal_asignado.Personal" class="text-no-wrap yellow lighten-3">{{item.pripersonal_asignado.Usuario}}</span>
                    </template>
                </template>
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.is_final">{{item.updated_at}}</span>
            </template>
        </v-data-table>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState, mapActions} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export default {
    name: 'TicketItem',
    mounted(){
        this.fuLoad(parseInt(this.$route.params.pid));
    },
    data: () => ({
        dIsUpdating: false,
        dLoading: false,
        dPriAlumno: {
            DNI: '',
            Alumno: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: '',
            ServicioIniciales: '',
        },
        dCrmTicket:{
            detalle: '',
            created_at: '',
            updated_at: '',
            tipo: '',
            estado: '',
        },
        dCrmTicketComentarios:[],
        dCrmTicketComentarioItem: null,
        dCrmTicketComentario_mensaje: '',
        dCrmTicketComentario_id_operador: null,
        dCrmTicketTipoId: null,
        dCrmTicketTipos:[],
        dCrmTicketTipoModal: {
            dialog: false,
            IsUpdating: false,
        },
        dModalImagen: {
            dialog: false,
            src: '',
        },
        dModal: {
            dialog: false,
            editedIndex: -1,
            IsUpdating: false,
            tipo: 0,
        },
        dPriPersonals: [],
        dSnackbar: false,
        dServicio: '',
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'id', text: 'id', align: ' d-none'},
                {value: 'created_at', text: 'F. Creación', sortable: false},
                {value: 'pripersonal.Usuario', text: 'Personal', sortable: false},
                {value: 'mensaje', text: 'Proveido', sortable: false},
                {value: 'pripersonal_asignado.Usuario', text: 'Derivado a', sortable: false},
                {value: 'updated_at', text: 'F. Fin', sortable: false},
            ],
            loading: false,
            search: null,
        },
        dSelectedFile: null,
        dImagenMiniatura: '',
        dZendComments:[],
    }),
    computed: {
        ...mapState(['ssUser']),
        coImagen(){
            return this.dImagenMiniatura;
        }
    },
    methods: {
        ...mapActions(['saCrmTickets', 'saCrmTicketCount']),
        async fuLoad(pid) {
            this.dLoading = true;
            var vComments=[];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($id: ID!, $Id_Padre: Int!){
                            crmticket(id: $id){
                                detalle
                                created_at
                                updated_at
                                id_tipo
                                crmtickettipo{
                                    nombre
                                }
                                crmticketestado{
                                    nombre
                                }
                                crmcliente{
                                    id_tipo
                                    prialumno{
                                        Alumno
                                        DNI
                                        Telefono
                                        Codigo
                                        Celular
                                        priservicio{
                                            Descripcion
                                            Iniciales
                                        }
                                    }
                                    admvisita{
                                        Visitante
                                        Dni
                                        Telefono
                                        Celular
                                        priservicio{
                                            Descripcion
                                            Iniciales
                                        }
                                    }
                                }
                                crmticketcomentarios{
                                    id
                                    mensaje
                                    tipo
                                    pripersonal{
                                        Personal
                                        Usuario
                                    }
                                    pripersonal_asignado{
                                        Personal
                                        Usuario
                                    }
                                    created_at
                                    updated_at
                                    is_final
                                    file_url
                                }
                            }
                            pripersonalActivo{
                                IdPersonal
                                Personal
                            }
                            crmtickettipoById_Padre(Id_Padre: $Id_Padre){
                                id
                                nombre
                            }
                        }
                    `,
                    variables: {
                        id: pid,
                        Id_Padre: 12
                    }
                })
                if(response.data){
                    this.dCrmTicket.detalle = response.data.crmticket.detalle;
                    this.dCrmTicket.created_at = response.data.crmticket.created_at;
                    this.dCrmTicket.updated_at = response.data.crmticket.updated_at;
                    this.dCrmTicketTipoId = String(response.data.crmticket.id_tipo);
                    this.dCrmTicket.tipo = response.data.crmticket.crmtickettipo.nombre;
                    this.dCrmTicket.estado = response.data.crmticket.crmticketestado.nombre;

                    if(response.data.crmticket.crmcliente.id_tipo == 1){
                        this.dPriAlumno.DNI = response.data.crmticket.crmcliente.prialumno.DNI;
                        this.dPriAlumno.Alumno = response.data.crmticket.crmcliente.prialumno.Alumno;
                        this.dPriAlumno.Telefono = response.data.crmticket.crmcliente.prialumno.Telefono;
                        this.dPriAlumno.Codigo = response.data.crmticket.crmcliente.prialumno.Codigo;
                        this.dPriAlumno.Celular = response.data.crmticket.crmcliente.prialumno.Celular;
                        this.dPriAlumno.Servicio = response.data.crmticket.crmcliente.prialumno.priservicio.Descripcion;
                        this.dPriAlumno.ServicioIniciales = response.data.crmticket.crmcliente.prialumno.priservicio.Iniciales;
                    } else {
                        this.dPriAlumno.DNI = response.data.crmticket.crmcliente.admvisita.Dni;
                        this.dPriAlumno.Alumno = response.data.crmticket.crmcliente.admvisita.Visitante;
                        this.dPriAlumno.Telefono = response.data.crmticket.crmcliente.admvisita.Telefono;
                        this.dPriAlumno.Codigo = "VISITANTE";
                        this.dPriAlumno.Celular = response.data.crmticket.crmcliente.admvisita.Celular;
                        this.dPriAlumno.Servicio = "";
                        this.dPriAlumno.ServicioIniciales = "";
                        if(response.data.crmticket.crmcliente.admvisita.priservicio){
                            this.dPriAlumno.Servicio = response.data.crmticket.crmcliente.admvisita.priservicio.Descripcion;
                            this.dPriAlumno.ServicioIniciales = response.data.crmticket.crmcliente.admvisita.priservicio.Iniciales;
                        }
                    }
                    this.dCrmTicketComentarios = response.data.crmticket.crmticketcomentarios.sort((a, b) => a.id - b.id);;

                    this.dPriPersonals = response.data.pripersonalActivo;
                    this.dCrmTicketTipos = response.data.crmtickettipoById_Padre;
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema al mostrar Ticket.', 'error');
            } finally {
                this.dLoading = false;
                this.dCrmTicketComentarios.map(function(x) {
                    var vItem = [];

                    // if(vComments){
                    //     vItem = vComments.filter(y=> y.body.split("\n").join("").replace(/\s+/g, '') == x.mensaje.split("\n").join("").replace(/\s+/g, ''));
                    // }
                    
                    if(vItem){
                        if(x.created_at == null)
                            x.created_at=vItem[0].created_at;
                    }
                    return x;
                });
            }
        },
        fuModalClose(){
            this.dModal.dialog = false;
            this.dModal.tipo = 0;
            this.$nextTick(() => {
                this.dModal.editedIndex = -1;
            })
        },
        fuModal (item, tipo) {
            this.dModal.editedIndex = this.dCrmTicketComentarios.indexOf(item);
            this.dCrmTicketComentarioItem = Object.assign({}, item);
            this.dModal.tipo = tipo;
            this.dModal.dialog = true;
        },
        fuModalSave(){
            this.$refs.refModal.validate()
            if(!this.$refs.refMensaje.validate()){
                this.dSnackbar = true;
            } else {
                if(this.dModal.tipo == 2)
                    this.fuFinalizar();
                else{
                    if(this.dModal.tipo == 3)
                        this.fuDerivarUpdateCreate();
                    else
                        if(!this.$refs.refOperador.validate())
                            this.dSnackbar = true;
                        else
                            if(this.dModal.tipo == 0)
                                this.fuDerivarCreate();
                            else
                                this.fuDerivarUpdateCreate();
                }
            }
        },
        async fuFinalizar () {
            try {
                this.dModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmticketcomentarioUpdate($id: ID!, $file: Upload, $inputU: crmticketcomentarioUpdateInput!, $inputC: crmticketcomentarioCreateInput!, $id_ticket: ID!, $inputT: crmticketUpdateInput!){
                        crmticketUpdate(id:$id_ticket, input: $inputT){
                            crmticketestado{
                               nombre
                            }
                        }
                        crmticketcomentarioUpdate(id: $id, input: $inputU){
                            updated_at
                        }
                        crmticketcomentarioCreateFile(file: $file, input: $inputC){
                            id
                            mensaje
                            created_at
                            updated_at
                        }
                    }`,
                    variables: {
                        id: this.dCrmTicketComentarioItem.id,
                        file: this.dSelectedFile,
                        inputU: {
                            is_final: 1,
                            updated_at: moment().format("YYYYMMDD HH:mm:ss"),
                        },
                        inputC: {
                            id_ticket: parseInt(this.$route.params.pid),
                            id_operador: this.ssUser.IdPersonal,
                            mensaje: this.dCrmTicketComentario_mensaje,
                            id_operador_asignado: "",
                            tipo: 2,
                            is_final: 1,
                        },
                        id_ticket: parseInt(this.$route.params.pid),
                        inputT: {
                            id_estado: 3
                        },
                    }
                });
                if(response.data){
                    this.dCrmTicket.estado=response.data.crmticketUpdate.crmticketestado.nombre;
                    let vItemU = {
                        is_final: 1,
                        updated_at: response.data.crmticketcomentarioUpdate.updated_at
                    }
                    let vItemD = {
                        id: response.data.crmticketcomentarioCreateFile.id,
                        mensaje: response.data.crmticketcomentarioCreateFile.mensaje,
                        tipo: 2,
                        is_final: 1,
                        pripersonal: {
                            Personal: this.ssUser.Personal,
                            Usuario: this.ssUser.Usuario,
                        },
                        created_at: response.data.crmticketcomentarioCreateFile.created_at,
                        updated_at: response.data.crmticketcomentarioCreateFile.updated_at,
                    }
                    
                    Object.assign(this.dCrmTicketComentarios[this.dModal.editedIndex], vItemU);
                    this.dCrmTicketComentarios.push(vItemD);
                    Swal.fire('Correcto', 'Se finalizó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó..', 'error');
                this.fucrmticketcomentarios();
            } finally {
                this.dModal.IsUpdating = false;
                this.fuModalClose();
                this.dCrmTicketComentario_mensaje = "";
                this.fuCrmTickets();
            }
        },
        async fuDerivarCreate () {
            try {
                this.dModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation actualizar($file: Upload, $input: crmticketcomentarioCreateInput!, $id_ticket: ID!, $inputT: crmticketUpdateInput!){
                        crmticketUpdate(id:$id_ticket, input: $inputT){
                            crmticketestado{
                               nombre
                            }
                        }
                        crmticketcomentarioCreateFile(file: $file, input: $input){
                            id
                            mensaje
                            created_at
                            file_url
                            pripersonal_asignado{
                                Personal
                                Usuario
                            }
                        }
                    }`,
                    variables: {
                        file: this.dSelectedFile,
                        input: {
                            id_ticket: parseInt(this.$route.params.pid),
                            id_operador: this.ssUser.IdPersonal,
                            mensaje: this.dCrmTicketComentario_mensaje,
                            id_operador_asignado: this.dCrmTicketComentario_id_operador,
                            tipo: 1,
                        },
                        id_ticket: parseInt(this.$route.params.pid),
                        inputT: {
                            id_estado: 2
                        },
                    }
                });
                if(response.data){
                    this.dCrmTicket.estado=response.data.crmticketUpdate.crmticketestado.nombre;
                    let vItemD = {
                        id: response.data.crmticketcomentarioCreateFile.id,
                        mensaje: response.data.crmticketcomentarioCreateFile.mensaje,
                        tipo: 1,
                        pripersonal: {
                            Personal: this.ssUser.Personal,
                            Usuario: this.ssUser.Usuario,
                        },
                        pripersonal_asignado: {
                            Personal: response.data.crmticketcomentarioCreateFile.pripersonal_asignado.Personal,
                            Usuario: response.data.crmticketcomentarioCreateFile.pripersonal_asignado.Usuario,
                        },
                        created_at: response.data.crmticketcomentarioCreateFile.created_at,
                        updated_at: '',
                        file_url: response.data.crmticketcomentarioCreateFile.file_url,
                    }
                    this.dCrmTicketComentarios.push(vItemD);
                    Swal.fire('Correcto', 'Se derivó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se derivó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se derivó..', 'error')
                this.fucrmticketcomentarios();
            } finally {
                this.dModal.IsUpdating = false;
                this.fuModalClose();
                this.dCrmTicketComentario_mensaje = "";
                this.fuCrmTickets();
            }
        },
        async fuDerivarUpdateCreate () {
            try {
                this.dModal.IsUpdating = true;

                if(this.dModal.tipo == 3)
                    this.dCrmTicketComentario_id_operador = this.ssUser.IdPersonal;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmticketcomentarioUpdate($id: ID!, $file: Upload, $inputU: crmticketcomentarioUpdateInput!, $inputC: crmticketcomentarioCreateInput!, $id_ticket: ID!, $inputT: crmticketUpdateInput!){
                        crmticketUpdate(id:$id_ticket, input: $inputT){
                            crmticketestado{
                               nombre
                            }
                        }
                        crmticketcomentarioUpdate(id: $id, input: $inputU){
                            updated_at
                        },
                        crmticketcomentarioCreateFile(file: $file, input: $inputC){
                            id
                            mensaje
                            created_at
                            pripersonal_asignado{
                                Personal
                                Usuario
                            }
                        }
                    }`,
                    variables: {
                        id: this.dCrmTicketComentarioItem.id,
                        file: this.dSelectedFile,
                        inputU: {
                            is_final: 1,
                            updated_at: moment().format("YYYYMMDD HH:mm:ss"),
                        },
                        inputC: {
                            id_ticket: parseInt(this.$route.params.pid),
                            id_operador: this.ssUser.IdPersonal,
                            mensaje: this.dCrmTicketComentario_mensaje,
                            id_operador_asignado: this.dCrmTicketComentario_id_operador,
                            tipo: 1,
                        },
                        id_ticket: parseInt(this.$route.params.pid),
                        inputT: {
                            id_estado: 2
                        },
                    }
                });
                if(response.data){
                    this.dCrmTicket.estado=response.data.crmticketUpdate.crmticketestado.nombre;
                    let vItemU = {
                        is_final: 1,
                        updated_at: response.data.crmticketcomentarioUpdate.updated_at
                    }
                    let vItemD = {
                        id: response.data.crmticketcomentarioCreateFile.id,
                        mensaje: response.data.crmticketcomentarioCreateFile.mensaje,
                        tipo: 1,
                        pripersonal: {
                            Personal: this.ssUser.Personal,
                            Usuario: this.ssUser.Usuario,
                        },
                        pripersonal_asignado: {
                            Personal: response.data.crmticketcomentarioCreateFile.pripersonal_asignado.Personal,
                            Usuario: response.data.crmticketcomentarioCreateFile.pripersonal_asignado.Usuario,
                        },
                        created_at: response.data.crmticketcomentarioCreateFile.created_at,
                        updated_at: '',
                    }
                    
                    Object.assign(this.dCrmTicketComentarios[this.dModal.editedIndex], vItemU);
                    this.dCrmTicketComentarios.push(vItemD);
                    Swal.fire('Correcto', 'Se derivó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se derivó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se derivó..', 'error');
                this.fucrmticketcomentarios();
            } finally {
                this.dModal.IsUpdating = false;
                this.fuModalClose();
                this.dCrmTicketComentario_mensaje = "";
                this.fuCrmTickets();
            }
        },
        async fuCrmTickets(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query consulta($id_operador_asignado: Int!, $token: String){
                        crmticketcomentarioByid_operador_asignadoByis_finalTop10(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            id
                            mensaje
                            created_at
                            crmticket{
                                id
                                crmcliente{
                                    id_tipo
                                    prialumno{
                                        Alumno
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                    admvisita{
                                        Visitante
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                }
                            }
                        }
                        crmticketcomentarioByid_operador_asignadoByis_finalCount(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            data
                        }
                    }`,
                    variables: {
                        id_operador_asignado: this.ssUser.IdPersonal,
                        token: new Date().toISOString()
                    }
                })
                this.saCrmTickets(response.data.crmticketcomentarioByid_operador_asignadoByis_finalTop10);
                this.saCrmTicketCount(response.data.crmticketcomentarioByid_operador_asignadoByis_finalCount.data);
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuCrmTicketTipoUpdate(){
            try {
                this.dCrmTicketTipoModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmticketUpdate($id: ID!, $input: crmticketUpdateInput!){
                        crmticketUpdate(id: $id, input: $input){
                            id_tipo
                            crmtickettipo{
                                nombre
                            }
                        }
                    }`,
                    variables: {
                        id: parseInt(this.$route.params.pid),
                        input: {
                            id_tipo: this.dCrmTicketTipoId
                        }
                    }
                });
                if(response.data){
                    this.dCrmTicketTipoId = String(response.data.crmticketUpdate.id_tipo);
                    this.dCrmTicket.tipo = response.data.crmticketUpdate.crmtickettipo.nombre;
                    this.dCrmTicketTipoModal.dialog = false;
                    Swal.fire('Correcto', 'Se modificó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó..', 'error');
            } finally {
                this.dCrmTicketTipoModal.IsUpdating = false;
            }
        },
        async fucrmticketcomentarios() {
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($id_ticket: Int!){
                            crmticketcomentarioByid_ticket(id_ticket: $id_ticket){
                                id
                                mensaje
                                tipo
                                pripersonal{
                                    Personal
                                    Usuario
                                }
                                pripersonal_asignado{
                                    Personal
                                    Usuario
                                }
                                created_at
                                updated_at
                                is_final
                            }
                        }
                    `,
                    variables: {
                        id_ticket: parseInt(this.$route.params.pid)
                    }
                })
                if(response.data){
                    this.dCrmTicketComentarios = [];
                    this.dCrmTicketComentarios = response.data.crmticketcomentarioByid_ticket;
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema al mostrar Ticket.', 'error');
            } finally {
            }
        },
        onFileSelected(event) {
            this.dSelectedFile = event.target.files[0];
            
            let reader = new FileReader();
            reader.onload = (e) => {
                this.dImagenMiniatura = e.target.result;
            }
            reader.readAsDataURL(this.dSelectedFile);
        }
    }
}
</script>